import React, { useState } from "react";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";

import "./searchSupplierHeader.css";

const SearchSupplierHeader = ({ onSupplierClicked }) => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();
  const [supplier, setSupplier] = useState({
    supplier_id: "",
    supplier_name: "",
  });
  const [SuggestionSupplier, setSuggestionSupplier] = useState([]);

  const checkSupplierAutoComplete = (keyword) => {
    if (keyword.length > 3) {
      findSupplier(keyword);
    } else {
      setSuggestionSupplier([]);
    }
  };

  // =====================
  // Request Method
  // =====================

  const findSupplier = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/supplier/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionSupplier(data.supplier);
    } catch (error) {
      setSuggestionSupplier([]);
    }
  };
  return (
    <div>
      <p>Nama Supplier: </p>
      <div className="input-field-container-supplier">
        <input
          type="text"
          value={supplier.supplier_name || ""}
          onChange={(e) => {
            const value = e.target.value;
            setSupplier((prevData) => ({
              ...prevData,
              supplier_name: value,
            }));
            checkSupplierAutoComplete(value);
          }}
          placeholder="Masukkan nama Supplier"
        />
      </div>
      {SuggestionSupplier.length > 0 && (
        <ul className="dropdown-list">
          {SuggestionSupplier.map((supplier) => (
            <li key={supplier.supplier_id}>
              <button
                className="dropdown-button"
                onClick={() => {
                  setSupplier(() => ({
                    supplier_id: supplier.supplier_id,
                    supplier_name: supplier.supplier_name,
                  }));
                  setSuggestionSupplier([]);
                  onSupplierClicked(supplier.supplier_id);
                }}
              >
                {supplier.supplier_name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchSupplierHeader;
